import React, { useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import './VendreEnLot.css';

const VendreEnLot = ({ show, onHide, selectedVehicles, onSuccess, selectedVehiclesCount, numero_dossier }) => {
  const [modalError, setModalError] = useState(null);
  const [formData, setFormData] = useState({
    // Champs ancien propriétaire
    occ_app_1: '', // Type de propriétaire
    occ_app_2: '', // Sexe
    occ_app_3: '', // Nom et prénom
    occ_app_4: '', // Raison sociale
    occ_app_5: '', // N° SIRET
    occ_app_5_2: '', // N° SIREN
    occ_app_6: '', // Numéro de voie
    occ_app_7: '', // Complément
    occ_app_8: '', // Type de voie
    occ_app_9: '', // Nom de la voie
    occ_app_10: '', // Code postal
    occ_app_11: '', // Commune
    occ_app_13_1: '', // Date de cession - Jour
    occ_app_13_2: '', // Date de cession - Mois
    occ_app_13_3: '', // Date de cession - Année
    occ_app_14_1: '', // Heure de cession
    occ_app_14_2: '', // Minute de cession

    // Cases à cocher pour l'ancien propriétaire
    occ_app_15: '0', // Certification 1
    occ_app_16: '0', // Certification 2
    occ_app_17: '0', // Certification 3

    // Champs nouveau propriétaire
    occ_tit_1: '', // Type de propriétaire
    occ_tit_2: '', // Sexe
    occ_tit_3: '', // Nom et prénom
    occ_tit_4: '', // Nom d'usage
    occ_tit_5_1: '', // Date de naissance - Jour
    occ_tit_5_2: '', // Date de naissance - Mois
    occ_tit_5_3: '', // Date de naissance - Année
    occ_tit_6: '', // Commune de naissance
    occ_tit_7: '', // Département de naissance
    occ_tit_8: '', // Pays de naissance
    occ_tit_9: '', // Raison sociale
    occ_tit_10: '', // N° SIRET
    occ_tit_11: '', // N° SIREN
    occ_tit_12: '', // Etage / Escalier / Appartement
    occ_tit_13: '', // Immeuble / Résidence / Bâtiment
    occ_tit_14: '', // N° de la voie
    occ_tit_15: '', // Extension (bis, ter,...)
    occ_tit_16: '', // Type de voie
    occ_tit_17: '', // Libellé de voie
    occ_tit_18: '', // Lieu-dit / BP / Localité
    occ_tit_19: '', // Code postal
    occ_tit_20: '', // Commune
    occ_tit_21: '', // Téléphone portable
    occ_tit_22: '', // Adresse mail

    // Cases à cocher pour le nouveau propriétaire
    occ_tit_23: '0', // Certification 1
    occ_tit_24: '0', // Certification 2
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5002/api";

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const numericOnlyFields = ['occ_app_5_2', 'occ_app_6', 'occ_app_10'];

    if (numericOnlyFields.includes(name)) {
      const numericValue = value.replace(/[^0-9]/g, '');
      setFormData({
        ...formData,
        [name]: numericValue
      });
      return;
    }

    setFormData({
      ...formData,
      [name]: value.toUpperCase()
    });
  };

  const handleDateFieldChange = (e, fieldPrefix, part) => {
    const { value } = e.target;
    let newValue = value.replace(/[^0-9]/g, '');

    if (part === '1') { // Jour
      if (newValue.length > 2) newValue = newValue.slice(0, 2);
      if (newValue && parseInt(newValue) > 31) newValue = '31';
      if (newValue && parseInt(newValue) < 1 && newValue.length === 2) newValue = '01';
      if (newValue.length === 1 && e.type === 'blur') {
        newValue = '0' + newValue;
      }
    } else if (part === '2') { // Mois
      if (newValue.length > 2) newValue = newValue.slice(0, 2);
      if (newValue && parseInt(newValue) > 12) newValue = '12';
      if (newValue && parseInt(newValue) < 1 && newValue.length === 2) newValue = '01';
      if (newValue.length === 1 && e.type === 'blur') {
        newValue = '0' + newValue;
      }
    } else if (part === '3') { // Année
      newValue = newValue.slice(0, 4);
      const currentYear = new Date().getFullYear();
      if (newValue && parseInt(newValue) > currentYear && newValue.length === 4)
        newValue = currentYear.toString();
    }

    setFormData({
      ...formData,
      [`${fieldPrefix}_${part}`]: newValue
    });
  };

  const handleCheckboxChange = (name) => {
    setFormData({
      ...formData,
      [name]: formData[name] === '1' ? '0' : '1'
    });
  };

  const handleSireneLookup = async (siretOrSiren, role) => {
    const cleaned = (siretOrSiren || "").replace(/\D/g, "");

    if (cleaned.length !== 9 && cleaned.length !== 14) {
      setModalError("Le numéro SIREN (9) ou SIRET (14) est invalide.");
      return;
    }

    try {
      const response = await axios.get(`${API_URL}/insee/verify/${cleaned}`);
      const etab = response.data.etablissement;
      const adr = etab?.adresseEtablissement || {};
      const ul = etab?.uniteLegale || {};

      setModalError(null);

      setFormData((prev) => {
        if (role === 'vendeur') {
          return {
            ...prev,
            occ_app_4: ul?.denominationUniteLegale || prev.occ_app_4,
            occ_app_5_2: cleaned.slice(0, 9),
            occ_app_6: adr?.numeroVoieEtablissement || prev.occ_app_6,
            occ_app_8: adr?.typeVoieEtablissement || prev.occ_app_8,
            occ_app_9: adr?.libelleVoieEtablissement || prev.occ_app_9,
            occ_app_10: adr?.codePostalEtablissement || prev.occ_app_10,
            occ_app_11: adr?.libelleCommuneEtablissement || prev.occ_app_11
          }          
        }

        if (role === 'acheteur') {
          return {
            ...prev,
            occ_tit_9: ul?.denominationUniteLegale || prev.occ_tit_9,
            occ_tit_11: cleaned.slice(0, 9),
            occ_tit_14: adr?.numeroVoieEtablissement || prev.occ_tit_14,
            occ_tit_16: adr?.typeVoieEtablissement || prev.occ_tit_16,
            occ_tit_17: adr?.libelleVoieEtablissement || prev.occ_tit_17,
            occ_tit_19: adr?.codePostalEtablissement || prev.occ_tit_19,
            occ_tit_20: adr?.libelleCommuneEtablissement || prev.occ_tit_20
          }
        }
        return prev;
      });
    } catch (err) {
      setModalError(err.response?.data?.message || err.message || "Erreur inconnue");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Début de handleSubmit');
    console.log('Données du formulaire:', formData);
    console.log('Véhicules sélectionnés:', selectedVehicles);

    if (selectedVehicles.length === 0) {
      alert("Veuillez sélectionner au moins un véhicule");
      return;
    }

    try {
      setIsSubmitting(true);
      console.log('Mise à jour des véhicules...');

      // Filtrer les champs vides du formulaire
      const filteredFormData = Object.entries(formData).reduce((acc, [key, value]) => {
        if (value !== '') {
          acc[key] = value;
        }
        return acc;
      }, {});

      console.log('Données filtrées:', filteredFormData);

      // Pour chaque véhicule, mettre à jour le statut
      const updatePromises = selectedVehicles.map(vehicleId =>
        axios.put(`${API_URL}/vehicules/${vehicleId}/status`,
          {
            statut: "Vendu",
            ...filteredFormData
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          }
        )
      );

      await Promise.all(updatePromises);
      console.log('Modifications terminées avec succès');

      onSuccess();
      alert(`${selectedVehicles.length} véhicule(s) mis à jour avec succès`);
    } catch (error) {
      console.error("Erreur détaillée:", error);
      console.error("Réponse d'erreur:", error.response?.data);
      alert("Erreur lors de la mise à jour des statuts des véhicules");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDownload = async () => {
    if (selectedVehicles.length === 0) {
      alert("Veuillez sélectionner au moins un véhicule");
      return;
    }

    try {
      setIsSubmitting(true);
      console.log('Véhicules sélectionnés:', selectedVehicles);

      // Récupérer uniquement les véhicules sélectionnés
      const vehiclesResponse = await axios.get(`${API_URL}/vehicules`, {
        params: {
          ids: selectedVehicles.join(',')
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      console.log('Réponse des véhicules:', vehiclesResponse.data);

      if (!vehiclesResponse.data || vehiclesResponse.data.length === 0) {
        throw new Error("Aucun véhicule trouvé");
      }

      // Filtrer pour ne garder que les véhicules sélectionnés
      const selectedVehiclesData = vehiclesResponse.data.filter(vehicle =>
        selectedVehicles.includes(vehicle.id)
      );

      console.log('Véhicules sélectionnés filtrés:', selectedVehiclesData);

      // Créer une nouvelle fenêtre pour afficher les PDFs
      // Prépare l'affichage des PDF
      const pdfWindow = window.open('', '_blank');

      // Tableau pour stocker les URLs des PDFs
      const pdfUrls = [];

      for (const vehicle of selectedVehiclesData) {
        const response = await axios.post(`${API_URL}/pdfs/generate-pdf`, {
          selectedVehicles: [vehicle.id],
          formData: formData,
          cerfa_types: ["15776-02", "13751-02"]
        }, {
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        });

        const pdfUrl = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        pdfUrls.push({ url: pdfUrl, filename: `CERFA_${vehicle.numero_dossier}.pdf` });
      }

      pdfWindow.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>Documents CERFA</title>
            <style>
              body {
                font-family: Arial, sans-serif;
                margin: 20px;
                background-color: #f5f5f5;
                font-size: 1.5rem;
              }
              .pdf-section {
                background-color: white;
                padding: 20px;
                margin-bottom: 20px;
                border-radius: 5px;
                box-shadow: 0 2px 4px rgba(0,0,0,0.1);
              }
              .pdf-section h3 {
                color: #ad974f;
                border-bottom: 2px solid #ad974f;
                padding-bottom: 10px;
                margin-bottom: 20px;
                font-size: 2rem;
              }
              .pdf-container {
                width: 100%;
                height: 800px;
                border: none;
              }
              .download-all-button {
                display: inline-block;
                margin: 20px auto;
                padding: 12px 24px;
                background-color: #ad974f;
                color: white;
                border: none;
                border-radius: 8px;
                font-size: 1.2rem;
                font-weight: bold;
                cursor: pointer;
                text-align: center;
                transition: background-color 0.3s ease, transform 0.2s ease;
                box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
              }
              .download-all-button:hover {
                background-color: #ad974f;
                transform: translateY(-2px);
              }
              .download-all-button:active {
                background-color: #ad974f;
                transform: translateY(0);
              }
            </style>
            <script src="https://unpkg.com/pdf-lib/dist/pdf-lib.min.js"></script>
          </head>
          <body>
            <h1>Documents CERFA</h1>
            <button class="download-all-button" id="downloadAll">Tout télécharger</button>

            ${pdfUrls.map(pdf => `
              <div class="pdf-section">
                <h3>${pdf.filename}</h3>
                <iframe class="pdf-container" src="${pdf.url}"></iframe>
              </div>
            `).join('')}

            <script>
              document.getElementById('downloadAll').addEventListener('click', async () => {
                try {
                  const mergedPdf = await PDFLib.PDFDocument.create();

                  const pdfs = ${JSON.stringify(pdfUrls)};
                  for (const pdf of pdfs) {
                    const response = await fetch(pdf.url);
                    const pdfBytes = await response.arrayBuffer();
                    const loadedPdf = await PDFLib.PDFDocument.load(pdfBytes);
                    const pages = await mergedPdf.copyPages(loadedPdf, loadedPdf.getPageIndices());
                    pages.forEach(page => mergedPdf.addPage(page));
                  }

                  const mergedPdfBytes = await mergedPdf.save();
                  const blob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement('a');
                  a.href = url;
                  a.download = 'Documents_CERFA_Fusionnes.pdf';
                  a.click();
                  URL.revokeObjectURL(url);
                } catch (err) {
                  console.error('Erreur lors de la fusion des PDFs:', err);
                  alert('Erreur lors de la fusion des PDFs');
                }
              });
            </script>
          </body>
        </html>
      `);
      pdfWindow.document.close();


    } catch (error) {
      console.error("Erreur lors de la génération des PDFs:", error);
      if (error.response) {
        // Si la réponse est un JSON, essayer de le lire
        if (error.response.data instanceof Blob) {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const errorData = JSON.parse(reader.result);
              console.error("Détails de l'erreur:", errorData);
            } catch (e) {
              console.error("Impossible de lire les détails de l'erreur");
            }
          };
          reader.readAsText(error.response.data);
        } else {
          console.error("Détails de l'erreur:", error.response.data);
        }
      }
      alert("Erreur lors de la génération des PDFs");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={(e) => {
      if (e.target.className === 'modal-overlay') {
        onHide();
      }
    }}>
      <div className="modal-content">
        <div className="modal-header">
          <h2>VENTRE EN LOT</h2>
          <button className="close-button" onClick={onHide}>✕</button>
        </div>

        <div className="modal-body">
          <p className="selected-count">
            {selectedVehiclesCount} véhicule(s) sélectionné(s)
            {Array.isArray(numero_dossier) && numero_dossier.length > 0 && ` - Dossier(s) n° ${numero_dossier.join(', ')}`}
          </p>

          <form onSubmit={handleSubmit}>
            <div className="form-section ancien-proprietaire">
              <h3>Ancien propriétaire</h3>
              <div className="modale-form-group">
                <label>VOUS ÊTES:</label>
                <div className="radio-group-child">
                  <div>
                    <input
                      type="radio"
                      id="occ_app_1_physique"
                      name="occ_app_1"
                      value="0"
                      checked={formData.occ_app_1 === '0'}
                      onChange={() => handleInputChange({ target: { name: 'occ_app_1', value: '0' } })}
                    />
                    <label htmlFor="occ_app_1_physique">PERSONNE PHYSIQUE</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="occ_app_1_morale"
                      name="occ_app_1"
                      value="1"
                      checked={formData.occ_app_1 === '1'}
                      onChange={() => handleInputChange({ target: { name: 'occ_app_1', value: '1' } })}
                    />
                    <label htmlFor="occ_app_1_morale">PERSONNE MORALE</label>
                  </div>
                </div>
              </div>

              {formData.occ_app_1 === '0' ? (
                <>
                  <div className="modale-form-group">
                    <label>SEXE:</label>
                    <div className="radio-group-child">
                      <div>
                        <input
                          type="radio"
                          id="occ_app_2_homme"
                          name="occ_app_2"
                          value="0"
                          checked={formData.occ_app_2 === '0'}
                          onChange={() => handleInputChange({ target: { name: 'occ_app_2', value: '0' } })}
                        />
                        <label htmlFor="occ_app_2_homme">MASCULIN</label>
                      </div>
                      <div>
                        <input
                          type="radio"
                          id="occ_app_2_femme"
                          name="occ_app_2"
                          value="1"
                          checked={formData.occ_app_2 === '1'}
                          onChange={() => handleInputChange({ target: { name: 'occ_app_2', value: '1' } })}
                        />
                        <label htmlFor="occ_app_2_femme">FÉMININ</label>
                      </div>
                    </div>
                  </div>

                  <div className="modale-form-group">
                    <label htmlFor="occ_app_3">NOM ET PRÉNOM:</label>
                    <input
                      type="text"
                      id="occ_app_3"
                      name="occ_app_3"
                      value={formData.occ_app_3 || ''}
                      onChange={handleInputChange}
                    />
                  </div>
                </>
              ) : formData.occ_app_1 === '1' ? (
                <>
                  <div className="modale-form-group">
                    <label htmlFor="occ_app_4">RAISON SOCIALE:</label>
                    <input
                      type="text"
                      id="occ_app_4"
                      name="occ_app_4"
                      value={formData.occ_app_4 || ''}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="modale-form-group siret-group">
                    <div className='input-group'>
                      <label htmlFor="occ_app_5">N° SIRET:</label>
                      <input
                        type="text"
                        id="occ_app_5"
                        name="occ_app_5"
                        maxLength="14"
                        pattern="[0-9]{14}"
                        value={formData.occ_app_5 || ''}
                        onChange={handleInputChange}
                      />
                    </div>
                    <button
                      type='button'
                      onClick={() => handleSireneLookup(formData.occ_app_5, 'vendeur')}
                      className='save-button'
                      title="Vérifier via l'API Sirene"
                    >
                      Vérifier le SIRET
                    </button>
                  </div>
                  {modalError && (
                    <p className="error-message" style={{ color: 'red', marginTop: '0.5rem' }}>{modalError}</p>
                  )}
                  <div className="modale-form-group">
                    <label htmlFor="occ_app_5_2">N° SIREN:</label>
                    <input
                      type="text"
                      id="occ_app_5_2"
                      name="occ_app_5_2"
                      maxLength="9"
                      pattern="^\d{9}$"
                      value={formData.occ_app_5_2 || ''}
                      onChange={handleInputChange}
                    />
                  </div>
                </>
              ) : null}

              <div className="modale-form-group">
                <label htmlFor="occ_app_6">N° DE LA VOIE:</label>
                <input
                  type="text"
                  id="occ_app_6"
                  name="occ_app_6"
                  value={formData.occ_app_6 || ''}
                  onChange={handleInputChange}
                />
              </div>

              <div className="modale-form-group">
                <label htmlFor="occ_app_7">COMPLÉMENT (BIS, TER,..):</label>
                <input
                  type="text"
                  id="occ_app_7"
                  name="occ_app_7"
                  value={formData.occ_app_7 || ''}
                  onChange={handleInputChange}
                />
              </div>

              <div className="modale-form-group">
                <label htmlFor="occ_app_8">TYPE DE VOIE (RUE, AVENUE..):</label>
                <input
                  type="text"
                  id="occ_app_8"
                  name="occ_app_8"
                  value={formData.occ_app_8 || ''}
                  onChange={handleInputChange}
                />
              </div>

              <div className="modale-form-group">
                <label htmlFor="occ_app_9">NOM DE LA VOIE:</label>
                <input
                  type="text"
                  id="occ_app_9"
                  name="occ_app_9"
                  value={formData.occ_app_9 || ''}
                  onChange={handleInputChange}
                />
              </div>

              <div className="modale-form-group">
                <label htmlFor="occ_app_10">CODE POSTAL:</label>
                <input
                  type="text"
                  id="occ_app_10"
                  name="occ_app_10"
                  value={formData.occ_app_10 || ''}
                  onChange={handleInputChange}
                />
              </div>

              <div className="modale-form-group">
                <label htmlFor="occ_app_11">COMMUNE:</label>
                <input
                  type="text"
                  id="occ_app_11"
                  name="occ_app_11"
                  value={formData.occ_app_11 || ''}
                  onChange={handleInputChange}
                />
              </div>

              <div className="modale-form-group">
                <label>Date de cession</label>
                <div className="modale-date-input-group">
                  <div className="modale-date-field">
                    <input
                      type="text"
                      id="occ_app_13_1"
                      name="occ_app_13_1"
                      value={formData.occ_app_13_1 || ''}
                      onChange={(e) => handleDateFieldChange(e, 'occ_app_13', '1')}
                      onBlur={(e) => handleDateFieldChange(e, 'occ_app_13', '1')}
                      placeholder="JJ"
                      maxLength="2"
                      required
                    />
                  </div>
                  <div className="modale-date-field">
                    <input
                      type="text"
                      id="occ_app_13_2"
                      name="occ_app_13_2"
                      value={formData.occ_app_13_2 || ''}
                      onChange={(e) => handleDateFieldChange(e, 'occ_app_13', '2')}
                      onBlur={(e) => handleDateFieldChange(e, 'occ_app_13', '2')}
                      placeholder="MM"
                      maxLength="2"
                      required
                    />
                  </div>
                  <div className="modale-date-field">
                    <input
                      type="text"
                      id="occ_app_13_3"
                      name="occ_app_13_3"
                      value={formData.occ_app_13_3 || ''}
                      onChange={(e) => handleDateFieldChange(e, 'occ_app_13', '3')}
                      onBlur={(e) => handleDateFieldChange(e, 'occ_app_13', '3')}
                      placeholder="AAAA"
                      maxLength="4"
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="modale-form-group">
                <label htmlFor="occ_app_14_time">Heure de cession</label>
                <input
                  type="time"
                  id="occ_app_14_time"
                  name="occ_app_14_time"
                  value={formData.occ_app_14_1 && formData.occ_app_14_2 ? `${formData.occ_app_14_1.padStart(2, '0')}:${formData.occ_app_14_2.padStart(2, '0')}` : ''}
                  onChange={(e) => {
                    const timeValue = e.target.value;
                    if (timeValue) {
                      const [hours, minutes] = timeValue.split(':');
                      setFormData({
                        ...formData,
                        occ_app_14_1: hours,
                        occ_app_14_2: minutes
                      });
                    } else {
                      setFormData({
                        ...formData,
                        occ_app_14_1: '',
                        occ_app_14_2: ''
                      });
                    }
                  }}
                  required
                />
              </div>

              <div className="modale-form-group">
                <label>JE CERTIFIE EN OUTRE (VEUILLEZ COCHER LA OU LES CASE.S CORRESPONDANTE.S):</label>
                <div className="checkbox-container">
                  <input
                    type="checkbox"
                    id="occ_app_15"
                    name="occ_app_15"
                    checked={formData.occ_app_15 === '1'}
                    onChange={() => handleCheckboxChange('occ_app_15')}
                  />
                  <label htmlFor="occ_app_15">
                    AVOIR REMIS AU NOUVEAU PROPRIÉTAIRE UN CERTIFICAT ÉTABLI DEPUIS MOINS DE QUINZE JOURS PAR LE MINISTRE DE L&apos;INTÉRIEUR, ATTESTANT À SA DATE D&apos;ÉDITION DE LA SITUATION ADMINISTRATIVE DU VÉHICULE
                  </label>
                </div>
                <div className="checkbox-container">
                  <input
                    type="checkbox"
                    id="occ_app_16"
                    name="occ_app_16"
                    checked={formData.occ_app_16 === '1'}
                    onChange={() => handleCheckboxChange('occ_app_16')}
                  />
                  <label htmlFor="occ_app_16">
                    QUE CE VÉHICULE N&apos;A PAS SUBI DE TRANSFORMATION NOTABLE SUSCEPTIBLE DE MODIFIER LES INDICATIONS DU CERTIFICAT DE CONFORMITÉ OU DE L&apos;ACTUEL CERTIFICAT D&apos;IMMATRICULATION
                  </label>
                </div>
                <div className="checkbox-container">
                  <input
                    type="checkbox"
                    id="occ_app_17"
                    name="occ_app_17"
                    checked={formData.occ_app_17 === '1'}
                    onChange={() => handleCheckboxChange('occ_app_17')}
                  />
                  <label htmlFor="occ_app_17">
                    QUE CE VÉHICULE EST CÉDÉ POUR DESTRUCTION À UN PROFESSIONNEL DE LA DESTRUCTION DES VÉHICULES HORS D&apos;USAGE (VHU)
                  </label>
                </div>
              </div>
            </div>

            <div className="form-section nouveau-proprietaire">
              <h3>Nouveau propriétaire</h3>
              <div className="modale-form-group">
                <label>VOUS ÊTES:</label>
                <div className="radio-group-child">
                  <div>
                    <input
                      type="radio"
                      id="occ_tit_1_physique"
                      name="occ_tit_1"
                      value="0"
                      checked={formData.occ_tit_1 === '0'}
                      onChange={() => handleInputChange({ target: { name: 'occ_tit_1', value: '0' } })}
                    />
                    <label htmlFor="occ_tit_1_physique">PERSONNE PHYSIQUE</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="occ_tit_1_morale"
                      name="occ_tit_1"
                      value="1"
                      checked={formData.occ_tit_1 === '1'}
                      onChange={() => handleInputChange({ target: { name: 'occ_tit_1', value: '1' } })}
                    />
                    <label htmlFor="occ_tit_1_morale">PERSONNE MORALE</label>
                  </div>
                </div>
              </div>

              {formData.occ_tit_1 === '0' ? (
                <>
                  <div className="modale-form-group">
                    <label>SEXE:</label>
                    <div className="radio-group-child">
                      <div>
                        <input
                          type="radio"
                          id="occ_tit_2_masculin"
                          name="occ_tit_2"
                          value="0"
                          checked={formData.occ_tit_2 === '0'}
                          onChange={() => handleInputChange({ target: { name: 'occ_tit_2', value: '0' } })}
                        />
                        <label htmlFor="occ_tit_2_masculin">MASCULIN</label>
                      </div>
                      <div>
                        <input
                          type="radio"
                          id="occ_tit_2_feminin"
                          name="occ_tit_2"
                          value="1"
                          checked={formData.occ_tit_2 === '1'}
                          onChange={() => handleInputChange({ target: { name: 'occ_tit_2', value: '1' } })}
                        />
                        <label htmlFor="occ_tit_2_feminin">FÉMININ</label>
                      </div>
                    </div>
                  </div>

                  <div className="modale-form-group">
                    <label htmlFor="occ_tit_3">NOM ET PRÉNOM:</label>
                    <input
                      type="text"
                      id="occ_tit_3"
                      name="occ_tit_3"
                      value={formData.occ_tit_3 || ''}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="modale-form-group">
                    <label htmlFor="occ_tit_4">NOM D&apos;USAGE (FACULTATIF):</label>
                    <input
                      type="text"
                      id="occ_tit_4"
                      name="occ_tit_4"
                      value={formData.occ_tit_4 || ''}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="modale-form-group">
                    <label>NÉ.E LE:</label>
                    <div className="modale-date-input-group">
                      <div className="modale-date-field">
                        <label htmlFor="occ_tit_5_1">JOUR</label>
                        <input
                          type="text"
                          id="occ_tit_5_1"
                          name="occ_tit_5_1"
                          value={formData.occ_tit_5_1 || ''}
                          onChange={(e) => handleDateFieldChange(e, 'occ_tit_5', '1')}
                          placeholder="JJ"
                        />
                      </div>
                      <div className="modale-date-field">
                        <label htmlFor="occ_tit_5_2">MOIS</label>
                        <input
                          type="text"
                          id="occ_tit_5_2"
                          name="occ_tit_5_2"
                          value={formData.occ_tit_5_2 || ''}
                          onChange={(e) => handleDateFieldChange(e, 'occ_tit_5', '2')}
                          placeholder="MM"
                        />
                      </div>
                      <div className="modale-date-field">
                        <label htmlFor="occ_tit_5_3">ANNÉE</label>
                        <input
                          type="text"
                          id="occ_tit_5_3"
                          name="occ_tit_5_3"
                          value={formData.occ_tit_5_3 || ''}
                          onChange={(e) => handleDateFieldChange(e, 'occ_tit_5', '3')}
                          placeholder="AAAA"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="modale-form-group">
                    <label htmlFor="occ_tit_6">COMMUNE DE NAISSANCE:</label>
                    <input
                      type="text"
                      id="occ_tit_6"
                      name="occ_tit_6"
                      value={formData.occ_tit_6 || ''}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="modale-form-group">
                    <label htmlFor="occ_tit_7">DÉPARTEMENT DE NAISSANCE:</label>
                    <input
                      type="text"
                      id="occ_tit_7"
                      name="occ_tit_7"
                      value={formData.occ_tit_7 || ''}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="modale-form-group">
                    <label htmlFor="occ_tit_8">PAYS DE NAISSANCE:</label>
                    <input
                      type="text"
                      id="occ_tit_8"
                      name="occ_tit_8"
                      value={formData.occ_tit_8 || ''}
                      onChange={handleInputChange}
                    />
                  </div>
                </>
              ) : formData.occ_tit_1 === '1' ? (
                <>
                  <div className="modale-form-group">
                    <label htmlFor="occ_tit_9">RAISON SOCIALE:</label>
                    <input
                      type="text"
                      id="occ_tit_9"
                      name="occ_tit_9"
                      value={formData.occ_tit_9 || ''}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="modale-form-group siret-group">
                    <div className='input-group'>
                      <label htmlFor="occ_tit_10">N° SIRET:</label>
                      <input
                        type="text"
                        id="occ_tit_10"
                        name="occ_tit_10"
                        maxLength="14"
                        value={formData.occ_tit_10 || ''}
                        onChange={handleInputChange}
                        pattern="[0-9]{14}"
                      />
                    </div>
                    <button
                      type='button'
                      onClick={() => handleSireneLookup(formData.occ_tit_10, 'acheteur')}
                      className='save-button'
                      title="Vérifier via l'API Sirene"
                    >
                      Vérifier le SIRET
                    </button>
                  </div>
                    {modalError && (
                      <p className="error-message" style={{ color: 'red', marginTop: '0.5rem' }}>{modalError}</p>
                    )}

                  <div className="modale-form-group">
                    <label htmlFor="occ_tit_11">N° SIREN:</label>
                    <input
                      type="text"
                      id="occ_tit_11"
                      name="occ_tit_11"
                      maxLength="9"
                      pattern="^\d{9}$"
                      value={formData.occ_tit_11 || ''}
                      onChange={handleInputChange}
                    />
                  </div>
                </>
              ) : null}

              <div className="modale-form-group">
                <label htmlFor="occ_tit_12">ETAGE / ESCALIER / APPARTEMENT:</label>
                <input
                  type="text"
                  id="occ_tit_12"
                  name="occ_tit_12"
                  value={formData.occ_tit_12 || ''}
                  onChange={handleInputChange}
                />
              </div>

              <div className="modale-form-group">
                <label htmlFor="occ_tit_13">IMMEUBLE / RÉSIDENCE / BÂTIMENT:</label>
                <input
                  type="text"
                  id="occ_tit_13"
                  name="occ_tit_13"
                  value={formData.occ_tit_13 || ''}
                  onChange={handleInputChange}
                />
              </div>

              <div className="modale-form-group">
                <label htmlFor="occ_tit_14">N° DE LA VOIE:</label>
                <input
                  type="text"
                  id="occ_tit_14"
                  name="occ_tit_14"
                  value={formData.occ_tit_14 || ''}
                  onChange={handleInputChange}
                />
              </div>

              <div className="modale-form-group">
                <label htmlFor="occ_tit_15">EXTENSION (BIS, TER, ..):</label>
                <input
                  type="text"
                  id="occ_tit_15"
                  name="occ_tit_15"
                  value={formData.occ_tit_15 || ''}
                  onChange={handleInputChange}
                />
              </div>

              <div className="modale-form-group">
                <label htmlFor="occ_tit_16">TYPE DE VOIE (RUE, AVENUE, ..):</label>
                <input
                  type="text"
                  id="occ_tit_16"
                  name="occ_tit_16"
                  value={formData.occ_tit_16 || ''}
                  onChange={handleInputChange}
                />
              </div>

              <div className="modale-form-group">
                <label htmlFor="occ_tit_17">LIBELLÉ DE VOIE:</label>
                <input
                  type="text"
                  id="occ_tit_17"
                  name="occ_tit_17"
                  value={formData.occ_tit_17 || ''}
                  onChange={handleInputChange}
                />
              </div>

              <div className="modale-form-group">
                <label htmlFor="occ_tit_18">LIEU-DIT / BP / LOCALITÉ:</label>
                <input
                  type="text"
                  id="occ_tit_18"
                  name="occ_tit_18"
                  value={formData.occ_tit_18 || ''}
                  onChange={handleInputChange}
                />
              </div>

              <div className="modale-form-group">
                <label htmlFor="occ_tit_19">CODE POSTAL:</label>
                <input
                  type="text"
                  id="occ_tit_19"
                  name="occ_tit_19"
                  value={formData.occ_tit_19 || ''}
                  onChange={handleInputChange}
                />
              </div>

              <div className="modale-form-group">
                <label htmlFor="occ_tit_20">COMMUNE:</label>
                <input
                  type="text"
                  id="occ_tit_20"
                  name="occ_tit_20"
                  value={formData.occ_tit_20 || ''}
                  onChange={handleInputChange}
                />
              </div>

              <div className="modale-form-group">
                <label htmlFor="occ_tit_21">TÉLÉPHONE PORTABLE:</label>
                <input
                  type="tel"
                  id="occ_tit_21"
                  name="occ_tit_21"
                  value={formData.occ_tit_21 || ''}
                  onChange={handleInputChange}
                />
              </div>

              <div className="modale-form-group">
                <label htmlFor="occ_tit_22">ADRESSE MAIL:</label>
                <input
                  type="email"
                  id="occ_tit_22"
                  name="occ_tit_22"
                  value={formData.occ_tit_22 || ''}
                  onChange={handleInputChange}
                />
              </div>

              <div className="modale-form-group">
                <label>CERTIFIE (VEUILLEZ COCHER LA OU LES CASE.S CORRESPONDANTE.S):</label>
                <div className="checkbox-container">
                  <input
                    type="checkbox"
                    id="occ_tit_23"
                    name="occ_tit_23"
                    checked={formData.occ_tit_23 === '1'}
                    onChange={() => handleCheckboxChange('occ_tit_23')}
                  />
                  <label htmlFor="occ_tit_23">
                    ACQUÉRIR LE VÉHICULE DÉSIGNÉ CI-DESSUS AUX DATES ET HEURES INDIQUÉES PAR L&apos;ANCIEN PROPRIÉTAIRE
                  </label>
                </div>
                <div className="checkbox-container">
                  <input
                    type="checkbox"
                    id="occ_tit_24"
                    name="occ_tit_24"
                    checked={formData.occ_tit_24 === '1'}
                    onChange={() => handleCheckboxChange('occ_tit_24')}
                  />
                  <label htmlFor="occ_tit_24">
                    AVOIR ÉTÉ INFORMÉ DE LA SITUATION ADMINISTRATIVE DU VÉHICULE
                  </label>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="cancel-button"
            onClick={onHide}
          >
            Annuler
          </button>
          <button
            type="button"
            className="download-button"
            onClick={handleDownload}
            disabled={isSubmitting}
          >
            Télécharger
          </button>
          <button
            type="button"
            className="submit-button"
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            Enregistrer
          </button>
        </div>
      </div>
    </div>

  );
};

VendreEnLot.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  selectedVehicles: PropTypes.array.isRequired,
  onSuccess: PropTypes.func.isRequired,
  selectedVehiclesCount: PropTypes.number.isRequired,
  numero_dossier: PropTypes.array.isRequired,
};

export default VendreEnLot;
